import { sortBy } from "../../../../Transactions/utils/helpers";

import { nextIndexForProperty } from "./orderHelpers";

const transactionExtrasOperations = (data) => {
  const collectionFor = (type) =>
    type === "expense"
      ? data.transaction_income.custom_transaction_expenses_attributes || []
      : data.transaction_income.custom_transaction_revenues_attributes || [];

  const combinedCollections = () => [...collectionFor("expense"), ...collectionFor("income")];
  const find = ({ type, id }) =>
    (type ? collectionFor(type) : combinedCollections()).find((lineItem) => lineItem.id === id);

  const nextPosition = () => nextIndexForProperty(combinedCollections(), "position");

  const reorderCollections = () => {
    // In place updating, as the rest of the actions
    // eslint-disable-next-line no-param-reassign
    data.transaction_income.custom_transaction_expenses_attributes = sortBy(
      data.transaction_income.custom_transaction_expenses_attributes || [],
      "position",
    );

    // In place updating, as the rest of the actions
    // eslint-disable-next-line no-param-reassign
    data.transaction_income.custom_transaction_revenues_attributes = sortBy(
      data.transaction_income.custom_transaction_revenues_attributes || [],
      "position",
    );
  };

  return {
    collectionFor,
    combinedCollections,
    find,
    nextPosition,
    reorderCollections,
  };
};

export default transactionExtrasOperations;
